import {
  Box,
  CircularProgress,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { RxCross1 } from "react-icons/rx";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getVoucher, getVoucherPbf } from "../../../../services/purchaseApi";
import useDebounce from "../../../hooks/useDebounce";
import moment from "moment";
import ModalVoucherTnc from "./ModalVoucherTnc";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalVoucher = ({ open, setOpen, selected, setSelected, total }) => {
  const [tempVoucher, setTempVoucher] = useState(null);
  const [search, setSearch] = useState("");
  const [openTnc, setOpenTnc] = useState(null);

  const debounce = useDebounce(search, 500);

  const { data: dataVoucher, isFetchingVoucher } = useQuery({
    queryFn: () => getVoucherPbf(),
    queryKey: ["voucher-purchase", open],
    enabled: open === true,
    refetchOnWindowFocus: false,
  });

  const handleClose = () => {
    setTempVoucher(null);
    setSearch("");
    setOpen(false);
  };

  const selectVoucher = () => {
    if (open)
      setSelected(
        tempVoucher
          ? dataVoucher.find((voucher) => voucher.voucher_uid === tempVoucher)
          : null,
      );
    handleClose();
  };

  useEffect(() => {
    if (open && selected) setTempVoucher(selected.voucher_uid);
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Kode Promo</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
          <div className="px-8 pb-4 flex items-center gap-2">
            {/* <TextField
              placeholder="Kode promo"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            /> */}
            {dataVoucher && dataVoucher.length > 0 ? (
              <button
                type="button"
                className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-full py-2 px-4 text-[14px] disabled:bg-gray-300"
                onClick={selectVoucher}
              >
                Terapkan Voucher Terpilih
              </button>
            ) : null}
          </div>

          <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[60vh]">
            <RadioGroup
              value={tempVoucher}
              onChange={(e) => setTempVoucher(e.target.value)}
            >
              {dataVoucher && !isFetchingVoucher && dataVoucher.length > 0 ? (
                dataVoucher.map((item) => (
                  <div className="mb-4">
                    <div
                      className={`flex justify-between items-stretch rounded-lg border-2 ${
                        // item.voucher_value_detail.voucher_value_type === 1 &&
                        // total < item.voucher_value_detail.voucher_min
                        !item.eligible ? "bg-gray-200" : "bg-white"
                      }`}
                    >
                      <div className="w-full px-4 py-2">
                        <p className="mb-2 text-[16px]">{item.voucher_name}</p>
                        <p>
                          Kode Promo: <b>{item.voucher_code}</b>
                        </p>
                        <p>{item.reason}</p>
                        {/* <p className="mb-2">
                          Berlaku hingga:{" "}
                          <b>
                            {moment()
                              .add(item.voucher_end + 1, "days")
                              .format("DD MMMM YYYY")}
                          </b>
                        </p> */}
                        {/* <p
                          className="font-bold text-[#071B82] cursor-pointer hover:underline"
                          onClick={() => setOpenTnc(item.voucher_uid)}
                        >
                          Syarat & Ketentuan
                        </p> */}
                      </div>
                      <div className="bg-gray-100 w-[100px] flex items-center justify-center">
                        <FormControlLabel
                          value={item.voucher_uid}
                          control={<Radio />}
                          sx={{ marginLeft: 2 }}
                          onClick={() =>
                            setTempVoucher(
                              tempVoucher === item.voucher_uid
                                ? null
                                : tempVoucher,
                            )
                          }
                          disabled={
                            // item.voucher_value_detail.voucher_value_type === 1
                            //   ? total < item.voucher_value_detail.voucher_min
                            //   : false
                            !item.eligible
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))
              ) : isFetchingVoucher ? (
                <CircularProgress size={20} />
              ) : (
                <p>Tidak ada voucher</p>
              )}
            </RadioGroup>
          </div>
        </Box>
      </Modal>

      <ModalVoucherTnc open={openTnc} setOpen={setOpenTnc} />
    </>
  );
};

export default ModalVoucher;
